import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { DealDrillPage } from './deals-management-drill-page'
import DealManagementHeaderSection from './deals-management-header'

/**
 * The Deals / Facilities landing page. It loads nothing itself: each grid is
 * one read (ADR_LOS-030) and the forms behind the Create buttons and the row
 * menus load the lists they offer when they open.
 */
export function DealManagmentPage() {
  return (
    <PageLayout>
      <DealManagementHeaderSection />
      <DealDrillPage />
    </PageLayout>
  )
}
